<app-kontable
  #appsConfigTable
  id="apps-config-table"
  title="{{ 'appsConfig.title' | translate }}"
  [columns]="['id', 'appId', 'appHostCode', 'configKey']"
  [titles]="['appsConfig.id', 'appsConfig.appId', 'appsConfig.appHostCode', 'appsConfig.configKey']"
  [source]="configs"
  [showInfoButton]="false"
  [showRecoverButton]="false"
  [showDetailsButton]="true"
  [showAddButton]="false"
  [showGlobalFilter]="false"
  [showEditButton]="true"
  [showDeleteButton]="false"
  [showReport]="false"
  (onDetails)="goToForm($event.appId,$event.configKey, true)"
  (onEdit)="goToForm($event.appId,$event.configKey, false)"
>
</app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/apps-config.component.html